export default "__VITE_ASSET__BgUnw$mc__"